import {WorkflowEventBindingsContainer} from './workflow-event-bindings-container';

export default {
    component: WorkflowEventBindingsContainer
};
